import { defineComponent } from '@vue/composition-api';
import HomeHero from '@/Home/HomeHero.vue';
export default defineComponent({
    components: {
        HomeHero
    },
    props: {
        blok: {
            type: Object,
            default: () => { }
        }
    }
});
